var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFilledCircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#06162D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7211 12.6414C17.7597 12.4413 17.7597 12.2054 17.7597 11.9848V11.9592C17.7321 8.58923 15.3961 6.24 12.1599 6.24C8.76354 6.23487 6.23975 8.57384 6.23975 12.0002C6.23975 15.4266 8.74145 17.7553 12.2648 17.7553C14.0826 17.8208 15.8509 17.1968 17.1633 16.0267L16.1582 14.8675C15.135 15.7599 13.7844 16.2569 12.3808 16.2576C11.3047 16.3006 10.2547 15.943 9.46359 15.2641C8.67251 14.5852 8.20584 13.6411 8.16711 12.6414H17.7211ZM8.19143 11.2052H8.18907V11.2206C8.18985 11.2155 8.19064 11.2103 8.19143 11.2052ZM8.19143 11.2052H15.8433C15.6058 9.13809 14.1534 7.81985 12.1211 7.81985C9.91777 7.81985 8.5001 9.21298 8.19143 11.2052Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCircleLogo);
export default __webpack_public_path__ + "static/media/Filled_Circle_Logo.f336f25eaeb2e39dbbb41b669b9d4f17.svg";
export { ForwardRef as ReactComponent };